// @packages
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import CtrlBreadcrum from '../../components/controls/master-page/ctrl-breadcrum';
import NotFoundPageContainer from '../PageNotFound/PageNotFoundContainer';
import { config } from '../../config';
import { mapComponent } from './component-mapper';
import { globalUI } from '../../core';
import Link from '@material-ui/core/Link';

// @styles
import styles from './styles';
import { dimensions } from '../../styles/globals';
import './styles.css';

const CtrlRoutes = ({
    classes,
    currentUrl,
    mainMenuIsExpanded
}) => {
    const masterPageContainerStyle = {};
    masterPageContainerStyle.marginLeft = mainMenuIsExpanded
        ? dimensions.MAIN_MENU_WIDTH
        : dimensions.MAIN_MENU_COLLAPSED_WIDTH;

    let Louversimage;
    if (currentUrl == "/" || currentUrl == "/products") {
      Louversimage = <><div style={{height: "30px"}}></div>
      <div className='divShadowLouver'>
        <div className="louverContainer">
            <Link  color="inherit" component="button" onClick={() => globalUI.navigateToUrl(globalUI.getDefaultUrl())}>
                <img className="louverImage" src={globalUI.getImage(`./${"LouverMontage"}.png`)}></img>            
            </Link>   
        </div>   
        <div className="louverTitle">Louvers</div>
      </div>      
      </>;
    } 

    return (
        <div className={classes.masterPage} style={masterPageContainerStyle}>
            <CtrlBreadcrum currentUrl={currentUrl} id="ctrl-breadcrum" />
            <Switch>
                {
                    config.routes.map((route, index) => (
                        <Route
                            component={mapComponent(route.component)}
                            exact
                            key={index}
                            path={route.url}
                        />
                    ))
                }
                <Route component={NotFoundPageContainer} />
            </Switch>
            {Louversimage}
        </div>
    );
};

CtrlRoutes.propTypes = {
    classes: PropTypes.object.isRequired,
    currentUrl: PropTypes.string.isRequired,
    mainMenuIsExpanded: PropTypes.bool.isRequired
};

export default withStyles(styles)(CtrlRoutes);
